module.exports = __webpack_public_path__ + "img/question3.c2a9fcac.svg";